import { Layout, Text } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'
import { LoadingState } from 'core/ui/async-content/LoadingState'

import expiredLinkImage from './assets/expired-link.svg'
import RateCommandCenterHeader from './RateCommandCenterHeader'

export type ExpiredStateProps = {
  emailRecipient?: string
  refreshTokenStatus: RequestStatus
  showHeader?: boolean
}

export default function ExpiredState({
  emailRecipient,
  refreshTokenStatus,
  showHeader = true,
}: ExpiredStateProps) {
  if (!emailRecipient && refreshTokenStatus === RequestStatus.Pending) {
    return <LoadingState />
  }

  return (
    <>
      {showHeader && <RateCommandCenterHeader />}
      <Layout.Stack gap="spacing-4" align="center" paddingT="spacing-12">
        <img alt="Email sent" src={expiredLinkImage} width={320} />
        <Layout.Stack gap="spacing-2" align="center">
          <Text variant="heading-sm-bold">We just sent you an e-mail</Text>
          <Text variant="body-md" style={{ textAlign: 'center' }}>
            For security reasons we sent another access link
            <br /> to {emailRecipient}. Verify your inbox.
          </Text>
        </Layout.Stack>
      </Layout.Stack>
    </>
  )
}
